import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaRegEdit } from "react-icons/fa";
import { Avatar, Button } from "antd";
import { botIconsMap } from "../../constants/chatPageConstants";
import { PageTitleContext } from "../../contexts/TitleContext";

const NewChatWithSameAssistant = ({ assistantName, assistantId }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isEmbedded, setIsEmbedded] = useState(false);
    const { pageTitle, setPageTitle } = useContext(PageTitleContext);

    useEffect(() => {
        const embeddedParam = new URLSearchParams(window.location.search).get("embedded") === "true";
        setIsEmbedded(embeddedParam);
    }, []);

    if (isEmbedded) {
        return null; // Return null to hide the component
    }

    const newChatIcon = botIconsMap.newChat.icon;

    return (
        <div>
            <div
                onClick={() => {
                    navigate(`/agents/${assistantId}`, { replace: true });
                }}
                style={{ padding: 0 }}
                className={`thread d-flex justify-content-between align-items-center`}
            >
                <span className="header-title">
                    {assistantName} &ensp;
                </span>
                <Button size="small">
                    New Chat <FaRegEdit className="" size={12} />
                </Button>
            </div>
        </div>
    );
};

export default NewChatWithSameAssistant;
